<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="Change My Pro" back-route="support" /></div>
    </div>
    <div class="columns">
      <main class="column is-6">
        <h4>Thanks for submitting your change pro request</h4>
        <p>
          We will work on finding a new pro to better service your lawn care needs. You will be
          notified when a new pro is assigned.
        </p>
        <LsButton
          class="back"
          text="back"
          track-id="change_my_pro-back_after_success"
          bg-color="primary"
          @click="$router.push({ name: 'support' })"
        />
      </main>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';
import { LsButton } from '@/components/common';

export default {
  name: 'ChangeProSuccess',
  components: { LsSupportHeader, LsButton },
};
</script>

<style lang="scss" scoped>
h4 {
  font-size: 1.8rem;
  & ~ p {
    margin: 1rem 0 3rem 0;
  }
}
</style>
